import { ALL_SDK_NETWORKS } from '@/config/query/queryParams'
import { type FixedTermMarket, getInternalAppSdk } from '@/utils/internalAppSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MILLISECONDS } from '@vaultsfyi/common/constants'

const fixedTermMarketsQueryKey = ['fixedTermMarkets'] as const

export const fixedTermMarketsQueryOptions = () => {
  return queryOptions({
    queryKey: fixedTermMarketsQueryKey,
    async queryFn(): Promise<FixedTermMarket[]> {
      const internalAppSdk = getInternalAppSdk()
      return await internalAppSdk.getFixedTermMarkets({ allowedNetworks: ALL_SDK_NETWORKS })
    },
    retry: 2,
    staleTime: 30 * MINUTE_IN_MILLISECONDS,
    refetchInterval: 30 * MINUTE_IN_MILLISECONDS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export type FixedTermMarketsQueryInitialData = ReturnType<typeof fixedTermMarketsQueryOptions>['initialData']

export const useFixedTermMarketsQuery = ({ initialData }: { initialData?: FixedTermMarketsQueryInitialData } = {}) => {
  const { data } = useQuery({
    ...fixedTermMarketsQueryOptions(),
    initialData,
  })

  return { data }
}
